import { render, staticRenderFns } from "./FrequentDispensing.vue?vue&type=template&id=2cdc8d02&scoped=true&"
import script from "./FrequentDispensing.vue?vue&type=script&lang=js&"
export * from "./FrequentDispensing.vue?vue&type=script&lang=js&"
import style0 from "./FrequentDispensing.vue?vue&type=style&index=0&id=2cdc8d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc8d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VContainer,VFlex,VLayout,VSubheader,VTextField})
